import { useEffect } from "react"
import { useWizard } from "../../../../components/wizard/WizardContext"
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../views/pages/manage/common/constant";
import { fetchAllCountriesAndBanks, fetchCoursePricingDetails, STUDENT } from "../multiTypeRefund/utils";

const COMPLETION_REFUND = 'COMPLETION_REFUND';

export const fetchCompletionRefundPayableInfo = async (studentDetails) => {
    const { psid, applicationId, businessArea, businessAreaDispVal, courseId, securityCourseId = null, academicCareerValue } = studentDetails;

    const req = {
        psid,
        applicationId,
        academicCareer: academicCareerValue,
        businessArea: businessAreaDispVal,
        businessAreaId: businessArea,
        regularCourseId: courseId,
        securityCourseId,
        refundDetails: [
            {
                subOrderType: COMPLETION_REFUND,
                bifurcationRequired: true
            }
        ]
    }

    const resp = await fetchAllPostPromisedData(endpoint.refund.multiTypeRefund.payableAmount, req);

    const { refundDetails } = resp?.data;
    return refundDetails[0] ?? {};


}

export const useGetCompletionRefundStep2Data = ({
    setLoading
}) => {

    const { values, setValues } = useWizard();
    const { selectedStudent, completionRefundStep2Data = {}, completionRefundUtils } = values;
    const { psid } = selectedStudent;

    const {studentAccountDetails, payableRefundInfo, coursePricingDetails } = completionRefundStep2Data;
    const {allBanks, allCountries} = completionRefundUtils;

    const fetchData = async () => {
        try {
            setLoading(true);
            const [countriesAndBanksData, studentAccounts, payableInfo, courseDetails] = await Promise.all([
                (!allBanks?.length || !allCountries?.length) ? fetchAllCountriesAndBanks() : { allBanks, allCountries },
                (!studentAccountDetails?.length ? fetchAllPromisedData(`${endpoint.studentBankDetails.getBankDetailsByPsid}/${psid}`) : studentAccountDetails),
                (Object.keys(payableRefundInfo)?.length === 0 ? fetchCompletionRefundPayableInfo(selectedStudent) : payableRefundInfo),
                (Object.keys(coursePricingDetails)?.length === 0 ? fetchCoursePricingDetails(selectedStudent) : coursePricingDetails)
            ]);

            setValues(vals => ({
                ...vals,
                completionRefundUtils: { ...countriesAndBanksData },
                completionRefundStep2Data: {
                    studentAccountDetails: studentAccounts?.map(el => ({ ...el, beneficiaryType: 'Student' })),
                    payableRefundInfo: payableInfo,
                    coursePricingDetails : courseDetails
                }
            }))


        } catch (err) {
            console.error(err);

        } finally {
            setLoading(false);

        }

    }

    useEffect(() => {
        fetchData();
    }, [])
}

const getInitCompletionRefundReq = (values) => {

    const {selectedStudent , completionRefundStep2Data} = values;
    const {
        psid,
        applicationId,
        studentName,
        businessAreaDispVal,
        businessArea,
        termDispVal,
        academicGroupDispValue,
        courseId,
        cashierOffice,
        // term,
        // academicGroup,
        // academicCareerValue,
    } = selectedStudent;

    const { primaryStudentAccount, payableRefundInfo } = completionRefundStep2Data;
    const {totalRefundableAmount} = payableRefundInfo;

    return {
        psid,
        applicationId,
        studentName,
        businessAreaValue : businessAreaDispVal,
        businessArea,
        termValue : termDispVal,
        regularCourseId : courseId,
        orderType : COMPLETION_REFUND,
        subOrderType : COMPLETION_REFUND,
        refund_status : "INPROGRESS",
        cashierOffice,
        academicCareerValue : academicGroupDispValue,
        refundAmount : totalRefundableAmount,
        // term,
        // academicGroup,
        // academicCareerValue,

        refundDto: {
            subOperationType: "InProgress",
            manualCompletionRefund: {
                term: payableRefundInfo?.termValue,
                courseId: payableRefundInfo?.courseId,
                paymentAccountDetails: [

                    {
                        beneficiaryType: STUDENT,
                        paymentModeType: primaryStudentAccount?.paymentModeType || "EFT",
                        bankMasterId: primaryStudentAccount?.bankMasterId,
                        bankKey: primaryStudentAccount?.bankKey,
                        paymentModeNumber: primaryStudentAccount?.accountNumber,
                        accountType: primaryStudentAccount?.bankAccountType,
                        ifscCode: primaryStudentAccount?.ifscCode,
                        beneficiaryName: primaryStudentAccount?.beneficiaryName,
                        supportingDocument: primaryStudentAccount?.attachmentKey,
                        paymentModeDate: primaryStudentAccount?.paymentModeDate,
                        refundableAmount: totalRefundableAmount
                    }
                ]

            }
        }

    }

}

export const initiateCompletionRefund = async ({forRefundEdit , values}) => {
    const req = getInitCompletionRefundReq(values);
    let url = forRefundEdit ? endpoint.refund.updateRefund : endpoint.refund.createRefund;
    return fetchAllPostPromisedData(url, req);

}